import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.66667 1.9974V5.33073C8.66667 5.69892 8.96514 5.9974 9.33333 5.9974H12.6667M5.66667 11.6641V10.3307M8 11.6641V8.33073M10.3333 11.6641V9.66406M3.66667 1.66406H8.39052C8.56734 1.66406 8.7369 1.7343 8.86193 1.85932L12.8047 5.80213C12.9298 5.92716 13 6.09673 13 6.27354V13.6641C13 14.0323 12.7015 14.3307 12.3333 14.3307H3.66667C3.29848 14.3307 3 14.0323 3 13.6641V2.33073C3 1.96254 3.29848 1.66406 3.66667 1.66406Z",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }